import { Path } from '@/types'

type HighlightCallback = (isHighlighted: boolean) => void

class HighlightedPathNotifier {
  private listeners: Map<string, HighlightCallback[]>

  constructor() {
    this.listeners = new Map<string, HighlightCallback[]>()
  }

  subscribe(path: Path, callback: HighlightCallback): void {
    const pathStr = path.toString()
    if (!this.listeners.has(pathStr)) {
      this.listeners.set(pathStr, [])
    }
    this.listeners.get(pathStr)?.push(callback)
  }

  unsubscribe(path: Path, callback: HighlightCallback): void {
    const pathStr = path.toString()
    const listeners = this.listeners.get(pathStr)
    if (listeners) {
      this.listeners.set(
        pathStr,
        listeners.filter((listener) => listener !== callback),
      )
    }
  }

  emit(path: Path, isHighlighted: boolean): void {
    const listeners = this.listeners.get(path.toString())
    if (listeners) {
      listeners.forEach((callback) => callback(isHighlighted))
    }
  }
}

export const highlightedPathNotifier = new HighlightedPathNotifier()
